export default __webpack_public_path__ + "media/images/map/car/128x128-51ae19c898577866b5b48daa70c2fac6.png";